/* eslint-disable import/prefer-default-export */
export const isProMemberModalVisible = state => state?.proMember?.modal
